/* src/app/core/modules/shared/components/empty-placeholder/empty-placeholder.component.scss */
/*# sourceMappingURL=/avvera/dev/empty-placeholder.component.css.map */
